export default __webpack_public_path__ + "static/media/52B16DBD-4015-4BF5-AC5E-325EB42562AA.31605590.jpg";